import { render, staticRenderFns } from "./ProgrammCreateUpdateInfo.vue?vue&type=template&id=dbd4841e&scoped=true&"
import script from "./ProgrammCreateUpdateInfo.vue?vue&type=script&lang=js&"
export * from "./ProgrammCreateUpdateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd4841e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/ProgrammCreateUpdateInfo.vue
// module id = null
// module chunks = 